/**
 * @file Post-save UI refresh helpers for permanent Recalls.
 */

import {
    removeCachedRecallDraft,
} from "./recallsState.js";

/**
 * Refreshes route state after a permanent Recall is saved.
 * @param {object} params Refresh params.
 * @param {Function} [params.onData=null] Rerender callback.
 * @returns {void}
 */
export function refreshRecallsAfterPermanentSave({
    onData = null,
} = {}) {
    onData?.();
}

/**
 * Refreshes route state after a shared draft is promoted.
 * @param {object} params Refresh params.
 * @param {object} [params.draft={}] Promoted draft data.
 * @param {Function} [params.onData=null] Rerender callback.
 * @param {object|null} [params.response=null] Promotion callable response.
 * @returns {void}
 */
export function refreshRecallsAfterDraftPromotion({
    draft = {},
    onData = null,
    response = null,
} = {}) {
    const draftId = response?.deletedDraftId || draft.id || null;
    if (draftId) {
        removeCachedRecallDraft(draftId);
    }
    refreshRecallsAfterPermanentSave({
        onData,
    });
}
